<form class="kRestoreForm" [formGroup]="_resendLinkForm">
  <h1>{{ 'app.login.invalidResetPasswordHash.title' | translate }}</h1>

  <ng-container *ngIf="_displayEmailField">
    <p [innerHTML]="'app.login.invalidResetPasswordHash.instructions' | translate"></p>

    <div>
      <input
        pInputText
        autocomplete="off"
        [placeholder]="'app.login.invalidResetPasswordHash.placeholder' | translate"
        [formControl]="_emailField"
        [ngClass]="{
          'has-error': errorMessage || _emailValidationMessage,
          'has-success': _emailField.valid && _emailField.touched
        }"
        [kTooltip]="_emailValidationMessage | translate"
        placement="right"
      />
    </div>

    <p *ngIf="errorMessage" class="kErrorMessage" [innerHTML]="errorMessage"></p>

    <div>
      <button
        class="kButtonDefault"
        pButton
        [label]="_resendBtnText | translate"
        [disabled]="inProgress"
        (click)="_resetPassword()"
      ></button>
    </div>
  </ng-container>
  <ng-container *ngIf="!_displayEmailField">
    <h1>{{ 'app.login.invalidResetPasswordHash.sentInstructions' | translate: _translateParam }}</h1>
    <div>
      <button
        class="kButtonDefault"
        pButton
        [label]="'app.common.ok' | translate"
        (click)="returnToLogin.emit()"
      ></button>
    </div>
  </ng-container>
</form>
